import type { AdminHotelOverviewRow } from "../types/adminOverview";
import type { AdminHotelMetricRow } from "../types/adminHotelMetricTable";

export function mapOverviewRowsToMetricRows(
  rows: AdminHotelOverviewRow[],
): AdminHotelMetricRow[] {
  return rows.map((row) => ({
    id: row.id,
    hotelBrand: row.hotelBrand,
    hotelLogoId: row.hotelLogoId,
    metrics: {
      serviceRevenue: {
        value: row.serviceRevenueFormatted,
        delta: row.serviceRevenueDelta,
        trend: row.serviceRevenueTrend,
      },
      conversionOfOffers: {
        value: row.conversionOfOffersFormatted,
        delta: row.conversionOfOffersDelta,
        trend: row.conversionOfOffersTrend,
      },
      avgGuestRating: {
        value: row.avgGuestRatingFormatted,
        delta: row.avgGuestRatingDelta,
        trend: row.avgGuestRatingTrend,
      },
      ordersForStay: {
        value: row.ordersForStayFormatted,
        delta: row.ordersForStayDelta,
        trend: row.ordersForStayTrend,
      },
    },
  }));
}
